import React from 'react'
import { StyleSheet } from 'react-native'
import Modal from '@dbk/ui-modal'
import Text from '@dbk/ui-text'
import Button from '@dbk/ui-buttons'
import { ErrorIcon, SuccessIcon } from '../../components/common/icons'
import { MODAL_TYPE } from '../../muster/app/payments/constant'

export default ({ onConfirm, onDone, messages, status, isMultiSigApprovalFlow }) => {
  const getStatusText = () => {
    if (status === MODAL_TYPE.CANCEL && isMultiSigApprovalFlow) {
      return {
        message: messages['app.payments.multisig.cancelStatusModalMessageApprover'],
        header: messages['app.payments.multisig.cancelStatusModalHeaderApprover'],
        title: messages['app.payments.multisig.cancelStatusModalTitleApprover'],
      }
    } else if (status === MODAL_TYPE.CANCEL && !isMultiSigApprovalFlow) {
      return {
        message: messages['app.payments.multisig.cancelStatusModalMessageInitiator'],
        header: messages['app.payments.multisig.cancelStatusModalHeaderInitiator'],
        title: messages['app.payments.multisig.cancelStatusModalTitleInitiator'],
      }
    } else if (status === MODAL_TYPE.REJECT) {
      return {
        message: messages['app.payments.multisig.rejectStatusModalMessage'],
        header: messages['app.payments.multisig.rejectStatusModalHeader'],
        title: messages['app.payments.multisig.rejectStatusModalTitle'],
      }
    }
    return { message: '', header: '', title: '' }
  }

  const statusText = getStatusText()
  return (
    <Modal
      isActive
      size="large"
      className={'model-window-login'}
      hideCloseButton
      title={statusText.title}
      disableOutsideClick
      onClose={() => {}}
      header={statusText.title}
      content={
        <div className="modal-payment-status">
          {
            <div className="modal-content">
              <div className="payment-status-message">
                <ErrorIcon width={30} height={30} />
                <Text size={'large'} tabIndex={0}>
                  {statusText.header}
                </Text>
              </div>
              <div tabIndex={0}>{statusText.message}</div>
            </div>
          }

          <div className="modal-footer">
            <div className="multisig-payment-btn-container">
              <div className="payment-btn margin-right-10">
                {status === MODAL_TYPE.CANCEL && (
                  <Button tertiary size={'large'} fullWidth onPress={() => onConfirm()}>
                    {messages['app.payments.new.payment']}
                  </Button>
                )}
              </div>
              <div className="payment-btn">
                <Button
                  className="btnPaymentDone"
                  size={'large'}
                  fullWidth
                  onPress={() => onDone()}
                >
                  {messages['app.payments.payment.done']}
                </Button>
              </div>
            </div>
          </div>
        </div>
      }
    />
  )
}
